import { getDefaultExportFromCjs as t } from "./index361.js";
import { __require as i } from "./index315.js";
var o = i();
const a = /* @__PURE__ */ t(o);
export {
  a as default
};
